import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Nav, Navbar, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../slices/keycloakSlice";
import "../pages/Common.css";
import bwcloudLogo from "../pages/images/bwcloud.png";
import { environment } from "../config.js";

// Sandwich menu component
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <button
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    className="navbar-toggler d-block custom-sandwich-btn"
  >
    <span className="navbar-toggler-icon"></span>
  </button>
));

const Header = () => {
  const dispatch = useDispatch();

  const logoutHandler = () => {
    dispatch(logout());
  };

  const isEnvNoAuth = environment === "production-no-auth";

  return (
    <div>
      <Navbar
        style={{ backgroundColor: "#A3C1DA", padding: "10px" }}
        variant="dark"
      >
        <div className="d-flex align-items-center">
          <img
            src={bwcloudLogo}
            style={{ width: "clamp(60px, 10vw, 100px)", marginRight: "10px" }}
            alt="bwCloud Logo"
          />
          <Link
            to="/"
            className="navbar-brand m-0"
            style={{ marginLeft: "20px" }}
          >
            <span
              className="navbar-text"
              style={{
                fontSize: "clamp(18px, 4vw, 35px)",
                whiteSpace: "nowrap",
                color: "rgba(0,0,0,0.55)",
              }}
            >
              Open Source VDI - ⚠️ THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST! - ⚠️ THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST! - ⚠️ THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST! - ⚠️  THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST! - ⚠️  THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST! - THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST! - <mark>THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST!</mark> - THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST! - THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST! Demo - THIS IS A DEVELOPMENT SERVER - YOUR DATA WILL BE LOST!
            </span>
          </Link>
        </div>

        {/* home button outside of the menu on large screens (d-none d-lg-flex) */}
        <Nav className="d-none d-lg-flex align-items-center ms-auto">
          <Link
            className="nav-link"
            to="/"
            style={{ color: "white", fontSize: "20px", marginRight: "15px" }}
          >
            Home
          </Link>
        </Nav>

        {/* SANDWICH MENU */}
        <Dropdown align="end" className="ms-auto ms-lg-0">
          <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components" />

          <Dropdown.Menu className="custom-dropdown-menu">
            {/* home button inside the menu on small screens (d-lg-none) */}
            <div className="d-lg-none">
              <Dropdown.Item as={Link} to="/">
                Home
              </Dropdown.Item>
              <Dropdown.Divider
                style={{ borderColor: "rgba(255,255,255,0.4)" }}
              />
            </div>

            {/* DEFAULT SANDWICH MENU */}
            <Dropdown.Item
              href="https://www.bw-cloud.org"
              target="_blank"
              rel="noreferrer"
            >
              FAQ
            </Dropdown.Item>
            <Dropdown.Item
              href="https://rz.uni-freiburg.de/de"
              target="_blank"
              rel="noreferrer"
            >
              About us
            </Dropdown.Item>
            <Dropdown.Item as={Link} to="/info">
              OSVDI Project
            </Dropdown.Item>

            <Dropdown.Item
              href="https://gitlab.uni-freiburg.de/opensourcevdi"
              target="_blank"
              rel="noreferrer"
            >
              Project repository
            </Dropdown.Item>

            <Dropdown.Divider
              style={{ borderColor: "rgba(255,255,255,0.4)" }}
            />

            {!isEnvNoAuth && (
              <>
                <Dropdown.Item as={Link} to="/account">
                  Account Details
                </Dropdown.Item>

                <Dropdown.Item as={Link} to="/settings">
                  Settings
                </Dropdown.Item>

                <Dropdown.Item as={Link} to="/" onClick={logoutHandler}>
                  Logout
                </Dropdown.Item>
              </>
            )}
          </Dropdown.Menu>
        </Dropdown>
      </Navbar>
    </div>
  );
};

export default Header;
